const form = document.getElementById('searchPageForm')
const newsroomTypeFilter = form.querySelector('#newsroomTypeFilterContainer')
const sortingSelect = document.querySelector('#sorting')

const loadingSpinnerWrapper = document.createElement('div')
const loadingSpinner = document.createElement('div')
loadingSpinnerWrapper.classList.add('spinner-wrapper')
loadingSpinner.classList.add('spinner-border', 'text-primary')
loadingSpinner.setAttribute('role', 'status')
loadingSpinner.innerHTML = '<span class="visually-hidden">Loading...</span>'
loadingSpinnerWrapper.append(loadingSpinner)

if (newsroomTypeFilter) {
  form.querySelector('#newsroomFilter').addEventListener('change', (event) => {

    if (event.target.checked) {
      newsroomTypeFilter.classList.add('show')
      newsroomTypeFilter.removeAttribute('aria-hidden')
    }
    else {
      newsroomTypeFilter.classList.remove('show')
      newsroomTypeFilter.setAttribute('aria-hidden', 'true')
    }
  })
}

if (sortingSelect) {
  sortingSelect.addEventListener('change', (event) => {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.submit()
    }
  })
}

form.addEventListener('submit', (event) => {
  event.preventDefault()
  document.body.append(loadingSpinnerWrapper)
  const url = event.target.action
  const formData = new FormData(event.target)
  let params = new URLSearchParams(formData)
  let sorting = ''

  if (sortingSelect) {
    sorting = sortingSelect.value
  }

  if (sorting !== '') {
    params.append('sortOrder', sorting)
  }

  if (event.target.querySelector('#newsroomFilter')?.checked) {
    let newParams = params.getAll('includePageTypes').toString()
    params.delete('includePageTypes')
    params.append('includePageTypes', newParams)
  } else {
     params.delete('includePageTypes')
  }

  window.location.assign(`${url}?${params.toString()}`)
})

// focus handling for accessibility on page load

document.addEventListener('DOMContentLoaded', function () {
  // No results
  const noresults = document.querySelector('#noResults')

  if (noresults) {
    noresults.focus()
  }
  else if (document.querySelector('#noContent')) {
    document.querySelector("#searchPageForm .search-input")?.focus();
  }
  else {
    document.querySelector('#searchResults')?.focus();
  }
})